import React, { useState, useEffect } from "react";
import { getPerfilUsuario, atualizarPerfilUsuario, logout, alterarSenhaUsuario } from "../../services/authService";
import { useNavigate } from "react-router-dom";
import "./Perfil.scss";
import { formatDate } from "../../utils/formatters";

const Perfil = () => {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState({
    id: 0,
    nome: "",
    email: "",
    telefone: "",
    dataCadastro: ""
  });
  
  const [edicao, setEdicao] = useState(false);
  const [dadosForm, setDadosForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);
  const [mensagem, setMensagem] = useState(null);
  const [alterarSenha, setAlterarSenha] = useState(false);
  const [senhaForm, setSenhaForm] = useState({
    senhaAtual: "",
    novaSenha: "",
    confirmarSenha: ""
  });
  const [verSenhaAtual, setVerSenhaAtual] = useState(false);
  const [verNovaSenha, setVerNovaSenha] = useState(false);
  const [estatisticas, setEstatisticas] = useState({
    totalMedicamentos: 0,
    totalModelos: 0,
    ultimoAcesso: null
  });
  const [modalConfirmacao, setModalConfirmacao] = useState(false);

  useEffect(() => {
    const buscarPerfil = async () => {
      try {
        setLoading(true);
        const data = await getPerfilUsuario();
        setUsuario(data);
        setDadosForm(data);
        
        // Aqui você pode buscar estatísticas reais
        // Este é apenas um exemplo estático
        setEstatisticas({
          totalMedicamentos: 12,
          totalModelos: 8,
          ultimoAcesso: new Date(Date.now() - 48 * 60 * 60 * 1000).toISOString()
        });
        
        setLoading(false);
      } catch (error) {
        console.error("Erro ao buscar perfil:", error);
        setErro("Não foi possível carregar os dados do perfil");
        setLoading(false);
      }
    };

    buscarPerfil();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDadosForm({
      ...dadosForm,
      [name]: value
    });
  };

  const handleSenhaChange = (e) => {
    const { name, value } = e.target;
    setSenhaForm({
      ...senhaForm,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await atualizarPerfilUsuario(usuario.id, dadosForm);
      setUsuario(dadosForm);
      setEdicao(false);
      setMensagem("Perfil atualizado com sucesso!");
      setTimeout(() => setMensagem(null), 3000);
      setLoading(false);
    } catch (error) {
      setErro("Erro ao atualizar o perfil. Tente novamente.");
      setTimeout(() => setErro(null), 3000);
      setLoading(false);
    }
  };

  const handleSubmitSenha = async (e) => {
    e.preventDefault();
    
    if (senhaForm.novaSenha !== senhaForm.confirmarSenha) {
      setErro("As senhas não coincidem. Verifique e tente novamente.");
      setTimeout(() => setErro(null), 3000);
      return;
    }
    
    try {
      setLoading(true);
      await alterarSenhaUsuario(usuario.id, {
        senhaAtual: senhaForm.senhaAtual,
        novaSenha: senhaForm.novaSenha
      });
      
      setAlterarSenha(false);
      setSenhaForm({
        senhaAtual: "",
        novaSenha: "",
        confirmarSenha: ""
      });
      
      setMensagem("Senha alterada com sucesso!");
      setTimeout(() => setMensagem(null), 3000);
      setLoading(false);
    } catch (error) {
      setErro("Erro ao alterar a senha. Verifique se a senha atual está correta.");
      setTimeout(() => setErro(null), 3000);
      setLoading(false);
    }
  };

  const handleCancelar = () => {
    setDadosForm(usuario);
    setEdicao(false);
  };
  
  const handleCancelarSenha = () => {
    setSenhaForm({
      senhaAtual: "",
      novaSenha: "",
      confirmarSenha: ""
    });
    setAlterarSenha(false);
  };
  
  const handleLogout = () => {
    logout();
    navigate("/");
  };

  if (loading && !usuario.id) {
    return (
      <div className="perfil-wrapper fade-in">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <div className="loading-text">Carregando perfil...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="perfil-wrapper fade-in">
      <h1>Meu Perfil</h1>
      
      {erro && <div className="mensagem erro">{erro}</div>}
      {mensagem && <div className="mensagem sucesso">{mensagem}</div>}
      
      <div className="perfil-grid">
        <div className="perfil-container perfil-principal">
          <div className="perfil-header">
            <div className="perfil-avatar">
              <div className="avatar-circle">
                {usuario.nome.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2)}
              </div>
              <h2>{usuario.nome}</h2>
              <p className="data-cadastro">
                <i className="fas fa-calendar-alt"></i> Membro desde {formatDate(usuario.dataCadastro)}
              </p>
            </div>
            
            {!edicao && !alterarSenha && (
              <div className="perfil-acoes">
                <button className="editar-btn" onClick={() => setEdicao(true)}>
                  <i className="fas fa-edit"></i> Editar Perfil
                </button>
                <button className="senha-btn" onClick={() => setAlterarSenha(true)}>
                  <i className="fas fa-key"></i> Alterar Senha
                </button>
                <button className="sair-btn" onClick={() => setModalConfirmacao(true)}>
                  <i className="fas fa-sign-out-alt"></i> Sair
                </button>
              </div>
            )}
          </div>
          
          {!edicao && !alterarSenha ? (
            <div className="info-cards">
              <div className="info-card">
                <div className="info-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="info-content">
                  <span className="info-label">Email</span>
                  <span className="info-value">{usuario.email}</span>
                </div>
              </div>
              
              <div className="info-card">
                <div className="info-icon">
                  <i className="fas fa-phone"></i>
                </div>
                <div className="info-content">
                  <span className="info-label">Telefone</span>
                  <span className="info-value">{usuario.telefone || "Não informado"}</span>
                </div>
              </div>
            </div>
          ) : edicao ? (
            <form className="perfil-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="nome">Nome Completo</label>
                <input 
                  type="text" 
                  id="nome" 
                  name="nome"
                  value={dadosForm.nome || ""} 
                  onChange={handleInputChange}
                  required
                  placeholder="Seu nome completo"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email"
                  value={dadosForm.email || ""} 
                  onChange={handleInputChange}
                  required
                  placeholder="seu@email.com"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="telefone">Telefone</label>
                <input 
                  type="tel" 
                  id="telefone" 
                  name="telefone"
                  value={dadosForm.telefone || ""} 
                  onChange={handleInputChange}
                  placeholder="(00) 00000-0000"
                />
              </div>
              
              <div className="form-actions">
                <button type="submit" className="salvar-btn">
                  <i className="fas fa-save"></i> Salvar
                </button>
                <button type="button" className="cancelar-btn" onClick={handleCancelar}>
                  <i className="fas fa-times"></i> Cancelar
                </button>
              </div>
            </form>
          ) : (
            <form className="perfil-form" onSubmit={handleSubmitSenha}>
              <h3>Alterar Senha</h3>
              <div className="form-group password-group">
                <label htmlFor="senhaAtual">Senha Atual</label>
                <div className="password-input-wrapper">
                  <input 
                    type={verSenhaAtual ? "text" : "password"} 
                    id="senhaAtual" 
                    name="senhaAtual"
                    value={senhaForm.senhaAtual} 
                    onChange={handleSenhaChange}
                    required
                    placeholder="Digite sua senha atual"
                  />
                  <button 
                    type="button" 
                    className="toggle-password"
                    onClick={() => setVerSenhaAtual(!verSenhaAtual)}
                  >
                    <i className={`fas ${verSenhaAtual ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                  </button>
                </div>
              </div>
              
              <div className="form-group password-group">
                <label htmlFor="novaSenha">Nova Senha</label>
                <div className="password-input-wrapper">
                  <input 
                    type={verNovaSenha ? "text" : "password"} 
                    id="novaSenha" 
                    name="novaSenha"
                    value={senhaForm.novaSenha} 
                    onChange={handleSenhaChange}
                    required
                    placeholder="Digite sua nova senha"
                  />
                  <button 
                    type="button" 
                    className="toggle-password"
                    onClick={() => setVerNovaSenha(!verNovaSenha)}
                  >
                    <i className={`fas ${verNovaSenha ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                  </button>
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="confirmarSenha">Confirme a Nova Senha</label>
                <input 
                  type="password" 
                  id="confirmarSenha" 
                  name="confirmarSenha"
                  value={senhaForm.confirmarSenha} 
                  onChange={handleSenhaChange}
                  required
                  placeholder="Confirme sua nova senha"
                />
              </div>
              
              <div className="senha-requisitos">
                <p>Sua senha deve conter:</p>
                <ul>
                  <li className={senhaForm.novaSenha.length >= 8 ? 'requisito-ok' : ''}>
                    <i className={`fas fa-${senhaForm.novaSenha.length >= 8 ? 'check' : 'times'}`}></i>
                    No mínimo 8 caracteres
                  </li>
                  <li className={/[A-Z]/.test(senhaForm.novaSenha) ? 'requisito-ok' : ''}>
                    <i className={`fas fa-${/[A-Z]/.test(senhaForm.novaSenha) ? 'check' : 'times'}`}></i>
                    Ao menos uma letra maiúscula
                  </li>
                  <li className={/[0-9]/.test(senhaForm.novaSenha) ? 'requisito-ok' : ''}>
                    <i className={`fas fa-${/[0-9]/.test(senhaForm.novaSenha) ? 'check' : 'times'}`}></i>
                    Ao menos um número
                  </li>
                </ul>
              </div>
              
              <div className="form-actions">
                <button 
                  type="submit" 
                  className="salvar-btn"
                  disabled={
                    senhaForm.novaSenha !== senhaForm.confirmarSenha ||
                    senhaForm.novaSenha.length < 8 ||
                    !(/[A-Z]/.test(senhaForm.novaSenha)) ||
                    !(/[0-9]/.test(senhaForm.novaSenha))
                  }
                >
                  <i className="fas fa-save"></i> Alterar Senha
                </button>
                <button type="button" className="cancelar-btn" onClick={handleCancelarSenha}>
                  <i className="fas fa-times"></i> Cancelar
                </button>
              </div>
            </form>
          )}
        </div>
        
        <div className="perfil-container perfil-estatisticas">
          <h3>Minhas Estatísticas</h3>
          
          <div className="estatisticas-list">
            <div className="estatistica-item">
              <div className="estatistica-icon">
                <i className="fas fa-pills"></i>
              </div>
              <div className="estatistica-conteudo">
                <span className="estatistica-valor">{estatisticas.totalMedicamentos}</span>
                <span className="estatistica-label">Medicamentos Cadastrados</span>
              </div>
            </div>
            
            <div className="estatistica-item">
              <div className="estatistica-icon">
                <i className="fas fa-clipboard-list"></i>
              </div>
              <div className="estatistica-conteudo">
                <span className="estatistica-valor">{estatisticas.totalModelos}</span>
                <span className="estatistica-label">Modelos Criados</span>
              </div>
            </div>
            
            <div className="estatistica-item">
              <div className="estatistica-icon">
                <i className="fas fa-calendar-check"></i>
              </div>
              <div className="estatistica-conteudo">
                <span className="estatistica-valor">{formatDate(estatisticas.ultimoAcesso, true)}</span>
                <span className="estatistica-label">Último Acesso</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {modalConfirmacao && (
        <div className="modal-overlay">
          <div className="modal-conteudo">
            <h3>Sair da Conta</h3>
            <p>Tem certeza que deseja sair da sua conta?</p>
            <div className="modal-acoes">
              <button className="confirmar-btn" onClick={handleLogout}>
                Sim, sair
              </button>
              <button className="cancelar-btn" onClick={() => setModalConfirmacao(false)}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Perfil;
